import { render, staticRenderFns } from "./addChargeDetailDialog.vue?vue&type=template&id=2e2cb6a3&scoped=true&"
import script from "./addChargeDetailDialog.vue?vue&type=script&lang=js&"
export * from "./addChargeDetailDialog.vue?vue&type=script&lang=js&"
import style0 from "./addChargeDetailDialog.vue?vue&type=style&index=0&id=2e2cb6a3&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../../../../Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e2cb6a3",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2e2cb6a3')) {
      api.createRecord('2e2cb6a3', component.options)
    } else {
      api.reload('2e2cb6a3', component.options)
    }
    module.hot.accept("./addChargeDetailDialog.vue?vue&type=template&id=2e2cb6a3&scoped=true&", function () {
      api.rerender('2e2cb6a3', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/cargo/v0/SeaExport/components/booking/addChargeDetailDialog.vue"
export default component.exports